{
  "google-salon-details-page": {
    "buttons": {
      "be-partner": "BÝT PARTNEREM",
      "request": "POŽÁDAT"
    },
    "text": {
      "is-customer-question": "Jste zákazníkem salonu?",
      "is-customer-hint": "Pokud si přejete online rezervaci salonu, dejte nám prosím vědět a my se spojíme s majitelem salonu.",
      "is-owner-question": "Jste majitelem salonu?",
      "is-owner-hint": "Staňte se naším partnerem a objevte naše neomezené funkce s velkou počáteční nabídkou!",
      "request-sent": "VÁŠ POŽADAVEK JE ODESLÁN"
    }
  }
}
